package one.healthium.reminders.di

import one.healthium.reminders.data.AppRemindersRepository
import one.healthium.reminders.data.mapper.ReminderMapper
import one.healthium.reminders.domain.RemindersInteractor
import one.healthium.reminders.domain.RemindersRepository
import one.primehealth.app.UserData
import org.koin.core.module.dsl.factoryOf
import org.koin.core.module.dsl.singleOf
import org.koin.dsl.bind
import org.koin.dsl.module

val remindersDataModule = module {
    singleOf(::AppRemindersRepository) bind RemindersRepository::class
    factoryOf(::ReminderMapper)
    singleOf(::RemindersInteractor) bind UserData::class
}